import { HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Observable } from 'rxjs';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
import { SERVICE_SUBSCRIPTION_KEY, SERVICE_API_KEY } from 'src/app/tokens';

@Injectable()
export class DefaultHeaderInterceptor implements HttpInterceptor {

  constructor(private userRulesService: UserRulesService, @Inject(SERVICE_SUBSCRIPTION_KEY) private ocpApimSubscriptionKey: string,
  @Inject(SERVICE_API_KEY) private apiKey: string, private auth: OidcClientService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const apiKey = this.apiKey;
    const subscriptionKey = this.ocpApimSubscriptionKey;
    let headers: HttpHeaders;
    if (req.headers.get('useAuth') === 'token') {
      headers = new HttpHeaders ({
        'api-key': apiKey,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        'Authorization': this.auth.getUser().id_token,
        ...(this.userRulesService.getAccessToken() && { Authorization2: this.userRulesService.getAccessToken()}),
        'Content-Type': 'application/json',
      });
    } else if (!req.url.includes('https://atlas.microsoft.com/geocode')) {
      headers = new HttpHeaders ({
        'api-key': apiKey,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        'Content-Type': 'application/json',
      });
    }
    // Clone the request and replace the original headers with
    const request = req.clone({ headers: headers });

    // send cloned request with header to the next handler.
    return next.handle(request);
  }
}
